import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix } from 'main/pages/Search/i18n'
import { spacing, typography } from 'main/ui'
import { numberOfActiveFilters } from 'main/util/search'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'

const PRE = `${i18nKeyPrefix}-MOBILE-FILTER`

interface IProps extends Omit<IFullSearchProps, 'palette'> {}

export default function MobileFilter(props: IProps) {
  const { filters, displayForm, onChangeFilters, onRequestCloseForm, onRequestDisplayForm } = props

  const filterCount = numberOfActiveFilters(filters)
  const isActive = filterCount > 0

  return (
    <div data-pendo="mobileFilterButton">
      <FilterControl
        displayForm={displayForm}
        isActive={isActive}
        label={filterControlLabel(filterCount)}
        onRequestDisplayForm={onRequestDisplayForm}
        onRequestCloseForm={onRequestCloseForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )
}

function filterControlLabel(filterCount: number) {
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  if (filterCount > 0) {
    return (
      <span>
        {t(`${PRE}-TITLE`)}
        <span css={{ marginLeft: spacing.majorScale(1), fontWeight: typography.fontWeight.bold }}>
          {filterCount}
        </span>
      </span>
    )
  }

  return t(`${PRE}-TITLE`)
}
